import styled from 'styled-components'
import { Button } from '@material-ui/core'

export const StyledMessage = styled.span`
  word-break: break-word;
` as any

export const StyledCopyButton = styled(Button)`
  padding: 0;
  svg {
    margin-right: 0.15em;
  }
`
